<script setup>
import {useForm, usePage} from "@inertiajs/vue3"
import CLink from "@/Components/CLink.vue"
import {computed} from "vue"
import {useDisplay} from "vuetify"

const props = defineProps({
    redirectTo: String,
    preserveState: Boolean,
    errorMessage: String,
    btnColor: String,
})

const currentUrl = computed(() => {
    return window.location.pathname + window.location.search
})

const options = portalOptions
const page = usePage()
const form = useForm({
    email: '',
    password: '',
    remember: false,
    redirectTo: props.redirectTo ?? currentUrl
})

const display = useDisplay()
const isMobile = computed(() => display.mdAndDown.value)
const user = computed(() => page.props.auth.user)

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
        preserveState: false,
    })
}
</script>

<template>
    <v-sheet rounded v-if="user">
        <p>Bem vindo(a), <span class="font-weight-bold">{{ user.name }}</span></p>
        <v-list density="compact" class="pt-2 pl-2">
            <v-list-item>
                <c-link :href="route('profile.orders')">
                    <v-icon v-if="isMobile" class="mr-2" color="rgb(78, 78, 78)">mdi-package-variant</v-icon>
                    <span v-if="!isMobile">Meus Pedidos</span>
                    <span v-else style="color: rgb(78, 78, 78);">Pedidos</span>
                </c-link>
            </v-list-item>
            <v-list-item>
                <c-link :href="route('profile.edit')">
                    <v-icon v-if="isMobile" class="mr-2" color="rgb(78, 78, 78)">mdi-account</v-icon>
                    <span v-if="!isMobile">Editar Perfil</span>
                    <span v-else style="color: rgb(78, 78, 78);">Perfil</span>
                </c-link>
            </v-list-item>
            <v-list-item v-if="page.props.auth.permissions.includes('admin portals')">
                <c-link :href="route('admin.dashboard')">
                    <v-icon v-if="isMobile" class="mr-2" color="rgb(78, 78, 78)">mdi-shield-account</v-icon>
                    <span style="color: rgb(78, 78, 78);">Administrativo</span>
                </c-link>
            </v-list-item>
            <v-list-item v-if="!isMobile">
                <c-link method="post" as="button" :href="route('logout')" :data="{ redirectTo: 'product.list' }">Sair</c-link>
            </v-list-item>
        </v-list>
    </v-sheet>
    <v-sheet class="py-5" rounded v-else>
        <form @submit.prevent="submit">
            <v-row>
                <v-col cols="12" md="12">
                    <v-text-field
                        label="Email"
                        placeholder="email@dominio.com.br"
                        v-model="form.email"
                        :error-messages="form.errors.email"
                        :hide-details="!form.errors.email"
                        :density="isMobile ? 'compact' : undefined"
                        prepend-inner-icon="mdi-email"
                        :color="isMobile ? 'rgb(78, 78, 78)' : undefined"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-text-field
                        label="Senha"
                        v-model="form.password"
                        type="password"
                        :error-messages="form.errors.password"
                        :hide-details="!form.errors.password"
                        :density="isMobile ? 'compact' : undefined"
                        prepend-inner-icon="mdi-lock"
                        :color="isMobile ? 'rgb(78, 78, 78)' : undefined"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <c-link :href="route('password.request')">
                        <v-icon v-if="isMobile" size="small" class="mr-1" color="rgb(78, 78, 78)">mdi-lock-reset</v-icon>
                        <span class="text-decoration-underline" :class="{'text-blue-darken-4': !isMobile, 'rgb-78-78-78': isMobile}" :style="isMobile ? 'color: rgb(78, 78, 78);' : ''">
                            <span v-if="!isMobile">Esqueceu sua senha?</span>
                            <span v-else>Recuperar senha</span>
                        </span>
                    </c-link>
                    <br v-if="!isMobile"/>
                    <c-link v-if="options.allowSelfSignUp" :href="route('register')" class="mt-2 d-inline-block">
                        <v-icon v-if="isMobile" size="small" class="mr-1" color="rgb(78, 78, 78)">mdi-account-plus</v-icon>
                        <span class="text-decoration-underline" :class="{'text-blue-darken-4': !isMobile}" :style="isMobile ? 'color: rgb(78, 78, 78);' : ''">Registrar</span>
                    </c-link>
                </v-col>
                <v-col cols="12" md="6" :class="isMobile ? 'text-center mt-4' : 'text-right pb-0'">
                    <v-btn type="submit" color="primary" :disabled="form.processing">
                        <v-icon v-if="isMobile" class="mr-2" color="rgb(78, 78, 78)">mdi-login</v-icon>
                        Log in
                    </v-btn>
                </v-col>
            </v-row>
        </form>
    </v-sheet>
</template>